import React from "react";
import { Button } from "antd";
import { useQuery } from "@apollo/client";
import { GET_STAFF_MANAGEMENT_EVENT } from "graphql/query/staff-management-gql";
import Events from "components/events";
import Icons from "components/icons";
import { PageWrapDefault } from "components/layout";
import { Localize } from "components/service";
import StaffManagement from "components/staff-management";
import StaffManagementEventRoute from "components/routes/staff-management/staff-management-event-route";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";


const basePath = StaffManagement.Const.basePath;

const StaffManagementEventPage = ({ match }) => {
    useActiveMenuItem([ "staff-management" ], [ "staff-management" ]);

    const eventID = match ? parseInt(match.params.eeID) : null;
    const { data: { exhibitionEvent: queriedEvent } = {}, loading } = useQuery(GET_STAFF_MANAGEMENT_EVENT, {
        skip: !eventID,
        variables: {
            id: eventID ? String(eventID) : undefined,
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });
    const event = String(queriedEvent?.id) === String(eventID) ? queriedEvent : null;
    const checkQr = StaffManagement.Hooks.useStaffCheckQr(event);

    useBreadCrumbs([
        {
            label: Localize({ children: "BREADCRUMBS.Label_StaffManagement" }).props.children,
            path: basePath,
        },
        ...(event ? [ {
            label: event.title,
            path: `${ basePath }/${ event.id }`,
        } ] : []),
    ]);

    const pageNavbar = [
        {
            label: Localize({ children: "STAFF_MANAGEMENT.Tab_CheckInSetup" }).props.children,
            path: "overview",
        },
        {
            label: Localize({ children: "STAFF_MANAGEMENT.Tab_Workers" }).props.children,
            path: "workers",
        },
        {
            label: Localize({ children: "STAFF_MANAGEMENT.Tab_Attendance" }).props.children,
            path: "attendance",
        },
        {
            label: Localize({ children: "STAFF_MANAGEMENT.Tab_AuditLog" }).props.children,
            path: "audit-log",
        },
    ];
    const headerRightBar = event && (
        <>
            { event.getCheckQrCodeUrl &&
                <Events.Actions.Fields.CheckQrGenerate
                    event={ event }
                    eventID={ eventID }
                    icon={ <Icons.StaffQrCode /> }
                    modalTitle={ <Localize>STAFF_MANAGEMENT.Modal_CheckInQr</Localize> }
                    variant="staff-management"
                    qrStatus={ checkQr.status }
                    qrUrl={ checkQr.qrUrl }
                    onGenerateQr={ checkQr.generateQr }
                    disabled={
                        checkQr.locationSaving ||
                        (
                            checkQr.status !== StaffManagement.Helpers.CheckQr.STAFF_CHECK_QR_STATUS.READY &&
                            !checkQr.canGenerate
                        )
                    }
                    buttonClassName="btn-icon-text" />
            }

            <Button className="btn-icon-text staff-management-detail__report-button staff-management-detail__report-button--attendance" disabled>
                <Icons.Download />
                <Localize>STAFF_MANAGEMENT.Action_AttendanceReport</Localize>
            </Button>

            <Button className="btn-icon-text staff-management-detail__report-button staff-management-detail__report-button--audit" disabled>
                <Icons.Download />
                <Localize>STAFF_MANAGEMENT.Action_AuditLogReport</Localize>
            </Button>
        </>
    );

    return (
        <PageWrapDefault
            className="page-staff-management-event"
            loading={ loading }
            title={ !loading && event ? event.title : "Page 404" }
            dataExist={ !loading && event }
            headerRightBar={ headerRightBar }
            pageNavbar={ !loading && event ? pageNavbar : false }
            staticPath={ `${ basePath }/${ eventID }` }>
            <StaffManagementEventRoute event={ event } checkQr={ checkQr } />
        </PageWrapDefault>
    );
};

export default StaffManagementEventPage;
